<template>
<v-container id="Login" class="Login">

  <v-layout wrap align-center justify-center>

    <v-flex xs12 sm12 md12 style="text-align: center" class="mt-3">
      <img src="../assets/lpn-logo.jpg" style="width: 180px"/>
    </v-flex>

    <AlertMessage :StatusShowMsg="StatusShowMsg" :MsgText="MsgText" :StatusAlert="StatusAlert" />
    <div class="flex xs12 md12 sm12" align="center">
      <h1 class="mt-3 text-xs-center">LPN Booking System</h1>
    </div>

    <v-flex xs12 sm4 md4 class="mt-4">
      <v-card class="card-border">
        <v-card-title></v-card-title>
        <v-card-text class="pt-2">
          <div>

            <v-form v-model="valid" ref="form">
              <v-text-field
                  label="ชื่อผู้ใช้งาน"
                  v-model="user_data.username"
                  :rules="usernameRules"
                  required

                  @keypress.enter="loginUser()"
              ></v-text-field>

              <!--<p class="blue-grey&#45;&#45;text font-weight-bold">รหัสผ่าน</p>-->
              <v-text-field
                  label="รหัสผ่าน"
                  v-model="user_data.password"
                  type="password"
                  :rules="passwordRules"
                  required

                  @keypress.enter="loginUser()"
                  autocomplete="false"
              ></v-text-field>
              <v-layout justify-space-between class="mt-2">
                <v-btn @click="loginUser" :class="valid ? 'blue darken-4 white--text':'grey white--text'" :disabled="!valid">ล๊อคอิน</v-btn>

                <v-btn class="" href="https://selfservice.lpn.co.th:8888/ss">ลืมรหัส/ปลดล๊อค</v-btn>
              </v-layout>
            </v-form>
          </div>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>

  <LoadingScreen :statusLoading="statusLoading" />
</v-container>
</template>

<script>

import axios_auth from "@/plugins/axios_auth";
import LoadingScreen from "@/components/widget/LoadingScreen";
import AlertMessage from "@/components/widget/AlertMessage";

export default {
  name: "Login",
  components: {
    LoadingScreen,
    AlertMessage
  },
  data() {
    return {
      valid: false,
      statusLoading: false,
      StatusShowMsg: false,
      MsgText: '',
      StatusAlert: '',
      user_data: {
        username:'',
        password: '',
        system:'rms-booking-system'
      },
      passwordRules: [
        (v) => !!v || 'กรุณากรอกรหัสผ่าน',
      ],
      usernameRules: [
        (v) => !!v || 'กรุณากรอกชื่อผู้ใช้งาน',
      ],
      error: {
        status:1,
        error_code:'401',
        msg:''
      },
      ss:''
    }
  },
  mounted: function () {

    this.$emit('showBack', false );


  },
  methods: {
    async loginUser() {
      this.statusLoading = true;
      try {
        axios_auth.post('/AuthSystem98218/Authentication', JSON.stringify(this.user_data))
            .then(res => {
              this.statusLoading = false;
              if (res.data.status === "1") {
                //set user token to localStorage
                let auth_data = {
                  'refreshToken': res.data.refreshToken,
                  'token': res.data.jwt,
                  'user_id': this.user_data.username
                }
                localStorage.setItem('RmsBookingAuth', JSON.stringify(auth_data))

              }

            }).then(() => {

              this.statusLoading = false;
              this.refreshToken().then((res) => {
                let auth_data = {
                  'refreshToken': res.refreshToken,
                  'token': res.jwt,
                  'user_id': this.user_data.username,
                  'availableUntil': res.availableUntil
                }

                localStorage.setItem('RmsBookingAuth', JSON.stringify(auth_data));
                this.CheckAccessSystem();

              });
            }).catch(err => {
                this.statusLoading = false;
                if (err.response) {

                  this.StatusShowMsg = true;
                  this.StatusAlert = 'error';
                  //this.error.status = err.response.data.status
                  //this.error.error_code = err.response.status
                  if (err.response.status === 401) {
                    this.MsgText = "ชื่อผู้ใช้งาน หรือ รหัสผ่านไม่ถูกต้อง"
                  } else {
                    this.MsgText = err.response.data.msg
                  }

                }
              });



      } catch (err2) {
        console.log(err2.message)
        this.statusLoading = false;
      }
    },
    CheckAccessSystem: async function(){

      this.setAuthHeader();

      let Result = await this.PostHttp('RmsSite/CheckLogin', {username: this.user_data.username});
      Result = Result.res.data;
      if (Result.statusAccess) {
        this.$emit('showLogoutMenu', {status: true});
        localStorage.setItem('RmsBookingUserAccess', JSON.stringify(Result));
        this.statusLoading = false;
        this.goToUrl('/HomeBooking');
        return true;

      } else {
        this.isAccessStatus = false;
        this.StatusShowMsg = true;
        this.MsgText = 'You Can not access system';
        this.StatusAlert = 'error';
        localStorage.removeItem('RmsBookingAuth');
        localStorage.removeItem('RmsBookingUserAccess');
        this.statusLoading = false;
        return false;
      }


    },

  }
}
</script>

<style scoped>

</style>